export default __webpack_public_path__ + "static/media/logo.474ca60d.svg";